import jwt_decode from 'jwt-decode'
import SessionCheck from './oidcsessioncheck/sessionCheckGlobal'

const generateEventHandlers = () => ['click', 'keypress', 'focusin'].map(eventName => ({
  eventName,
  handler: null,
}))
const addEventHandlers = (eventHandlers, sessionCheck) => {
  eventHandlers.forEach(handlerObj => {
    if (!handlerObj.handler) {
      handlerObj.handler = () => {
        sessionCheck.triggerSessionCheck()
      }
      window.addEventListener(handlerObj.eventName, handlerObj.handler)
    }
  })
}
const removeEventHandlers = eventHandlers => {
  eventHandlers.forEach(handlerObj => {
    if (handlerObj.handler) {
      window.removeEventListener(handlerObj.eventName, handlerObj.handler)
    } else {
      handlerObj.handler = null
    }
  })
}

export const useFRSessionCheck = (
  invalidSessionHandler,
  sessionClaimsHandler,
  forgerockIdToken,
  frOpUrl,
  frClientId,
  frRealm,
) => {
  const eventHandlers = generateEventHandlers()

  const redirectUri = window.location.origin + '/' + 'sessionCheck.html'
  const decodedForgerockIdToken = forgerockIdToken ? jwt_decode(forgerockIdToken) : {}
  const scope = 'openid email calabrio'
  const sessionCheck = new SessionCheck({
    clientId: `${frClientId}`,
    opUrl: `https://${frOpUrl}/am/oauth2/realms/root/realms${frRealm}/authorize`,
    subject: decodedForgerockIdToken.sub,
    invalidSessionHandler,
    sessionClaimsHandler,
    cooldownPeriod: 60,
    redirectUri,
    scope,
  })

  sessionCheck.triggerSessionCheck()
  addEventHandlers(eventHandlers, sessionCheck)
  return {
    sessionCheck,
    removeSessionCheckEventHandlers: () => removeEventHandlers(eventHandlers),
  }
}
